import { redirect } from '@tanstack/react-router';

/** Prod hits on dev-only routes behave like the catch-all: redirect to /login. */
export function devOnlyGuard() {
  if (!import.meta.env.DEV) throw redirect({ to: '/login', replace: true });
}
